export function getTotalPages(totalRecords: number, pageSize: number): number {
  return Math.ceil(totalRecords / pageSize)
}

export function getPaginationRange(
  currentPage: number,
  pageSize: number,
  totalRecords: number
) {
  const startItem = totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1
  const endItem = Math.min(currentPage * pageSize, totalRecords)

  return { startItem, endItem }
}

export function getPageNumbers(
  currentPage: number,
  totalPages: number
): Array<number | string> {
  const pages: Array<number | string> = []

  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i)
    }
    return pages
  }

  pages.push(1)

  if (currentPage <= 3) {
    pages.push(2, 3, 4)
    pages.push('...')
    pages.push(totalPages)
    return pages
  }

  if (currentPage >= totalPages - 2) {
    pages.push('...')
    pages.push(totalPages - 3, totalPages - 2, totalPages - 1, totalPages)
    return pages
  }

  pages.push('...')
  pages.push(currentPage - 1, currentPage, currentPage + 1)
  pages.push('...')
  pages.push(totalPages)

  return pages
}
